import { SharedPrizeCarousel } from 'components/prize-carousel/SharedPrizeCarousel';
import { homepagePrizeCarouselItems } from 'constants/Prizes';

export const PrizeCarousel = (props: { variant?: 'V4' }) => {
  return (
    <SharedPrizeCarousel
      items={homepagePrizeCarouselItems}
      textPosition="default"
      overlayVariant="gradient"
      showButtonsOnMobile={false}
      showButtonsOnDesktop={true}
      desktopInlinePadding="40px"
      slidePadding="var(--dm2025-gap-8)"
      variant={props.variant === 'V4' ? 'HomePage2026V4' : undefined}
    />
  );
};
